import { FaAngleDown, FaBriefcase, FaServer } from "react-icons/fa6";
import { FaHome } from "react-icons/fa";
import { BiSolidPhoneCall } from "react-icons/bi";
import { MdVideoCameraFront } from "react-icons/md";

const NavigationLinks = [
  {
    prefix: (
      <FaHome style={{ fontSize: "20px", color: "var(--primaryColor)" }} />
    ),
    name: "Home",
    link: "/",
    desc: "",
  },
  {
    prefix: (
      <FaBriefcase style={{ fontSize: "20px", color: "var(--primaryColor)" }} />
    ),
    name: "Venues",
    desc: "",
    icon: <FaAngleDown />,
    link: [{}],
  },
  {
    prefix: (
      <FaBriefcase style={{ fontSize: "20px", color: "var(--primaryColor)" }} />
    ),
    name: "Vendors",
    desc: "",
    icon: <FaAngleDown />,
    link: [{}],
  },
  {
    prefix: (
      <FaBriefcase style={{ fontSize: "20px", color: "var(--primaryColor)" }} />
    ),
    name: "Find by Cast",
    desc: "",
    icon: <FaAngleDown />,
    link: [{}],
  },
  {
    prefix: (
      <FaBriefcase style={{ fontSize: "20px", color: "var(--primaryColor)" }} />
    ),
    name: "Plan by Events",
    desc: "",
    icon: <FaAngleDown />,
    link: [{}],
  },
  {
    prefix: (
      <MdVideoCameraFront
        style={{ fontSize: "20px", color: "var(--primaryColor)" }}
      />
    ),
    name: "Blogs",
    // icon: <FaAngleDown />,
    desc: "",
    link: "/blogs",
  },
  // {
  //   prefix: (
  //     <BiSolidPhoneCall
  //       style={{ fontSize: "20px", color: "var(--primaryColor)" }}
  //     />
  //   ),
  //   name: "Get Support",
  //   link: "/online-marketing-near-mumbai",
  //   desc: "",
  // },
  // {
  //   prefix: (
  //     <BiSolidPhoneCall
  //       style={{ fontSize: "20px", color: "var(--primaryColor)" }}
  //     />
  //   ),
  //   name: "Know More",
  //   desc: "",
  //   icon: <FaAngleDown />,
  //   link: [
  //     { name: "About Us", link: "/about-us" },
  //     { name: "FAQ", link: "/faq" },
  //     { name: "Privacy Policy", link: "/privacy-policy" },
  //     { name: "Terms & Condition", link: "/terms-condition" },
  //   ],
  // },
];

export default NavigationLinks;
